<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Tłumaczenia modeli</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Tłumaczenia modeli</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Tłumaczenia modeli</h5>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <button @click="exportFile" class="btn btn-sm btn-primary">
                  <i class="fa fa-file-excel-o"></i>
                  Exportuj
                </button>
                <button
                  v-if="canChange"
                  @click="importFile = true"
                  class="btn btn-sm btn-primary"
                >
                  <i class="fa fa-cloud-upload"></i>
                  Importuj
                </button>
              </div>
              <div class="col-sm-6 m-b-xs">
                <div class="form-group rows-input-group">
                  <label class="control-label">Wpisz liczbę wierszy:</label>
                  <input
                    class="form-control inputClass"
                    type="text"
                    v-model="rowsPerPage"
                    @change="setRowsPerPage"
                    @click="isSearch = false"
                  />
                </div>
              </div>
              <div class="col-sm-6 m-b-xs" v-if="sitesOptions.length">
                <div class="form-group domain-select">
                  <label class="control-label">Domena</label>
                  <Multiselect
                    v-model="filterSitePk"
                    :options="sitesOptions"
                    placeholder="Wybierz domenę"
                    track-by="name"
                    label="name"
                    mode="single"
                    :close-on-select="true"
                    :searchable="true"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :clickRowToExpand="true"
                  :loading="loading"
                  @click-row="editRow"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />

                    <div v-if="header.radio" class="radio-filter">
                      Tylko puste
                      <input
                        type="checkbox"
                        v-model="radioValue[header.value]"
                        @click="setRadioFilter()"
                      />
                    </div>
                  </template>
                  <template #item-actions="item">
                    <div>
                      <button
                        v-if="item.isEdit && canChange"
                        @click="editSend"
                        class="btn btn-success btn-xs"
                      >
                        <i class="fa fa-check"></i>
                      </button>
                      <button
                        v-if="item.isEdit"
                        @click.stop="cancelEdit(item)"
                        class="btn btn-danger btn-xs"
                      >
                        <span class="fa fa-times"></span>
                      </button>
                      <button
                        v-if="!item.isEdit && canChange"
                        @click="editRow(item)"
                        class="btn btn-warning btn-xs"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                    </div>
                  </template>
                  <template #item-site="item">
                    <span>
                      {{ item.site?.name || "" }}
                    </span>
                  </template>
                  <template #item-pl="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.pl"
                          name="pl"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                        <div v-if="errorsAdminData?.data?.pl" class="has-error">
                          <span class="help-block">
                            {{ errorsAdminData.data.pl[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else v-html="item.pl"></span>
                  </template>
                  <template #item-en="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.en"
                          name="en"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                        <div v-if="errorsAdminData?.data?.en" class="has-error">
                          <span class="help-block">
                            {{ errorsAdminData.data.en[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else v-html="item.en"></span>
                  </template>
                  <template #item-cpde="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.cpde"
                          name="cpde"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                        <div
                          v-if="errorsAdminData?.data?.cpde"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.cpde[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else v-html="item.cpde"></span>
                  </template>
                  <template #item-cpen="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.cpen"
                          name="cpen"
                          type="text"
                          class="form-control inputClass"
                          required="required"
                        />
                        <div
                          v-if="errorsAdminData?.data?.cpen"
                          class="has-error"
                        >
                          <span class="help-block">
                            {{ errorsAdminData.data.cpen[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else v-html="item.cpen"></span>
                  </template>
                  <template #item-de="item">
                    <div v-if="item.isEdit">
                      <div class="col-sm-10">
                        <input
                          v-model="translateObj.de"
                          name="de"
                          class="form-control inputClass"
                          type="text"
                        />
                        <div v-if="errorsAdminData?.data?.de" class="has-error">
                          <span class="help-block">
                            {{ errorsAdminData.data.de[0] }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <span v-else v-html="item.de"></span>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="importFile" class="modal-dialog">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">Import tłumaczeń</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label for="excel_file" class="col-sm-2 control-label">
              Plik excel
            </label>
            <div class="col-sm-10">
              <div class="fileinput fileinput-new input-group">
                <div class="form-control">
                  <input
                    type="file"
                    name="file"
                    v-on:change="onFileChange"
                    multiple="multiple"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="importFile = false" class="btn btn-white">
            Anuluj
          </button>
          <button @click="importFileFn()" class="btn btn-primary">
            Importuj
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="importFile" class="modal-backdrop"></div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import {
  getSiteValueFromCurrentUrl,
  hasSiteOptionValue,
} from "../../site-domain";
import { hasPermission } from "../../permissions";
import { translationPermissionsConst } from "../../constants/translationConstants";

export default {
  name: "TranslationsModelsList",
  mixins: [],
  components: {
    Multiselect,
  },
  props: {},

  setup() {
    const store = useStore();
    const canChange = computed(() =>
      hasPermission(translationPermissionsConst.update)
    );
    const translateData = computed(() => store.getters.gettranslateData);
    const updateTranslationsModelsData = computed(
      () => store.getters.getUpdateTranslationsModelsData
    );
    const translationsModelsData = computed(
      () => store.getters.getTranslationsModelsData
    );
    const importTMData = computed(() => store.getters.getImportTMData);
    const translateObj = ref({
      name: "",
      value: false,
    });
    const errorsAdminData = ref();
    const filterSitePk = ref(null);
    const sitesOptions = ref([]);
    const siteFilterInitialized = ref(false);
    let headers = [
      { text: "Nr", value: "pk" },
      { text: "Model", value: "model", sortable: true, search: true },
      { text: "ID", value: "id", sortable: true, search: true },
      {
        text: "Pole",
        value: "field",
        sortable: true,
        search: true,
      },
      {
        text: "Domena",
        value: "site",
        sortable: false,
      },
      {
        text: "Polski",
        value: "pl",
        sortable: true,
        search: true,
      },
      {
        text: "Niemiecki",
        value: "de",
        sortable: true,
        radio: true,
        search: true,
      },
      {
        text: "Angielski",
        value: "en",
        sortable: true,
        radio: true,
        search: true,
      },
      {
        text: "Niemiecki (de)",
        value: "cpde",
        sortable: true,
        radio: true,
        search: true,
      },
      {
        text: "Angielski (de)",
        value: "cpen",
        sortable: true,
        radio: true,
        search: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const excelFile = ref("");
    const loading = ref(true);
    const searchValue = ref({});
    const radioValue = ref({});
    const isSearch = ref(false);
    const importFile = ref(false);
    const rowsPerPage = ref();
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });

    const sitesData = computed(() => store.getters.getSitesData);

    const getTranslationsModels = async () => {
      if (!siteFilterInitialized.value) {
        return;
      }
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getTranslationsModels", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        radio: radioValue.value,
        site_pk: filterSitePk.value,
      });
    };

    const saveEdit = () => {
      if (!canChange.value) {
        return;
      }

      store.dispatch("updateTranslationsModels", translateObj.value);
    };

    const exportFile = () => {
      store.dispatch("exportTranslationsModels");
    };

    const cancel = () => {
      document.querySelector(".expanding")?.click();
    };

    // Importing a file overwrites existing translations, so it needs the same
    // permission as editing them.
    const importFileFn = () => {
      if (!canChange.value) {
        return;
      }

      store.dispatch("importTranslationsModels", {
        excel_file: excelFile.value,
      });
    };

    const onFileChange = (e) => {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      excelFile.value = files[0];
    };

    const editSend = () => {
      if (!canChange.value) {
        return;
      }

      store.dispatch("updateTranslationsModels", translateObj.value);
    };

    const cancelEdit = (item) => {
      var keyObj = false;
      for (const [key, value] of Object.entries(items.value)) {
        items.value[key].isEdit = false;
        if (value.pk === item.pk) {
          keyObj = key;
        }
      }
      item.isEdit = false;
      if (keyObj) {
        translateObj.value = item;
        items.value[keyObj].isEdit = false;
      }
    };

    const editRow = (item) => {
      if (!canChange.value) {
        return;
      }

      var keyObj = false;
      for (const [key, value] of Object.entries(items.value)) {
        items.value[key].isEdit = false;
        if (value.pk === item.pk) {
          keyObj = key;
        }
      }

      if (keyObj) {
        translateObj.value = item;
        items.value[keyObj].isEdit = true;
      }
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getTranslationsModels();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      radioValue.value = {};
      serverOptions.value.sortBy = "";
      filterSitePk.value = null;
      getTranslationsModels();
    };

    const updateSort = () => {
      search.value = true;
    };

    const setRadioFilter = () => {
      isSearch.value = true;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("transmSearchValue") !== null) {
        searchValue.value = localStorage.getItem("transmSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      if (localStorage.getItem("transmRadioValue") !== null) {
        radioValue.value = localStorage.getItem("transmRadioValue");
        radioValue.value = JSON.parse(radioValue.value);
      }
      store.dispatch("getSites");
    });

    watch(
      () => [searchValue.value, radioValue.value],
      function () {
        localStorage.setItem(
          "transmSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "transmRadioValue",
          JSON.stringify(radioValue.value)
        );
        getTranslationsModels();
      },
      { deep: true }
    );

    watch(
      () => translationsModelsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => sitesData.value,
      function (newValue) {
        const raw = Array.isArray(newValue?.data?.results)
          ? newValue.data.results
          : Array.isArray(newValue?.data?.data)
          ? newValue.data.data
          : Array.isArray(newValue?.data)
          ? newValue.data
          : [];
        sitesOptions.value = raw.map((s) => ({ name: s.name, value: s.pk }));

        if (!hasSiteOptionValue(sitesOptions.value, filterSitePk.value)) {
          const defaultSiteValue = getSiteValueFromCurrentUrl(
            sitesOptions.value
          );
          if (defaultSiteValue !== null) {
            filterSitePk.value = defaultSiteValue;
          }
        }

        if (!siteFilterInitialized.value) {
          siteFilterInitialized.value = true;
          getTranslationsModels();
        }
      }
    );

    watch(
      () => filterSitePk.value,
      function () {
        serverOptions.value.page = 1;
        getTranslationsModels();
      }
    );

    watch(
      () => translateData.value,
      function (newValue) {
        translateObj.value = newValue.data;
      }
    );

    watch(
      () => radioValue.value,
      function () {
        getTranslationsModels();
      },
      { deep: true }
    );

    watch(
      () => updateTranslationsModelsData.value,
      function (newValue) {
        if (newValue.status === 200) {
          getTranslationsModels();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaktualizowane",
          });
        }

        cancel();
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getTranslationsModels();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    watch(
      () => importTMData.value,
      function (newValue) {
        if (newValue?.status === 200) {
          getTranslationsModels();
          store.dispatch("showToaster", {
            type: "success",
            content: "Dane zostały zaimportowane",
          });
        }
      }
    );

    return {
      headers,
      items,
      itemsAll,
      loading,
      canChange,
      serverOptions,
      translateObj,
      cancel,
      saveEdit,
      cancelEdit,
      editRow,
      errorsAdminData,
      editSend,
      searchValue,
      radioValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      filterSitePk,
      sitesOptions,
      exportFile,
      importFile,
      importFileFn,
      onFileChange,
      setRadioFilter,
      selectPage,
      setRowsPerPage,
    };
  },
  computed: {},
};
</script>

<style scoped>
.rows-input-group input {
  width: 160px;
}
.domain-select {
  position: relative;
  width: 320px;
  margin-left: auto;
}
.domain-select :deep(.multiselect) {
  z-index: 9999999;
}
.domain-select :deep(.multiselect-dropdown) {
  z-index: 9999999;
}
</style>
